import { createFileRoute } from "@tanstack/react-router";
import { ModuleGuard } from "@/components/auth/ModuleGuard";
import ProspectDetailPage from "@/pages/ProspectDetailPage";

export const Route = createFileRoute("/_app/prospects/$id")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <ModuleGuard module="prospects">
      <ProspectDetailPage />
    </ModuleGuard>
  );
}
